import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';

import { TokenService } from '@ninety/platform/services/services/token.service';
import { environment } from '@ninety/ui/web/environments';

export function NotificationsInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  // The empty-origin guard short-circuits in the unit-test environment, where `environment.local.ts`
  // (re-exported as the default `environment` in `environment.ts`) sets notificationsApiOrigin to ''.
  // In every other build (including the reverseProxy flow used by `npm start`) the origin is populated.
  if (environment.notificationsApiOrigin?.length === 0 || !req.url.startsWith(environment.notificationsApiOrigin)) {
    return next(req);
  }
  const tokenService = inject(TokenService);
  const token = tokenService.getAccessToken();
  if (!token) return next(req);
  const clonedRequest = req.clone({
    headers: req.headers.set('Authorization', `Bearer ${token}`),
  });
  return next(clonedRequest);
}
